import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Modal } from "antd";
import { domainServer } from "../../../constant/domain.js";
import {
  useLoginMutation,
  useSendOtpMutation,
} from "../../../store/mutations/auth.mutate.js";
import LoadingFullscreen from "../Loading/LoadingFullscreen.js";
import { useGetMeQuery } from "../../../store/queries/auth.query.js";
import APIs from "../../../constant/endpoint.js";
import { generateTokenFromProtoken } from "../../../helpers/login.helper.js";
import { Link, useNavigate } from "react-router-dom";
import { REGEX_EMAIL, USERNAME_REGEX } from "../../../constant/regex.js";
import { socket } from "../../../helpers/socket.helper.js";
import { StateContext } from "../../../context/reducer.js";
import { contextConstant } from "../../../context/constant.js";

function LoginModal() {
  const { state, dispatch } = useContext(StateContext);
  const { showLoginModal } = state;
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [usernamereg, setUsernameReg] = useState("");
  const [passwordreg, setPasswordReg] = useState("");
  const [emailreg, setEmaildReg] = useState("");
  const [message, setMessage] = useState("");
  const [registerMessage, setRegisterMessage] = useState("");
  const [processing, setProcessing] = useState(false);
  const [toggleLogin, setToggleLogin] = useState(false);

  const { mutateAsync: mutateLogin, isPending, isSuccess } = useLoginMutation();
  const { isLoading, data, isSuccess: getMeSuccess } = useGetMeQuery();

  const { isPending: isSending } = useSendOtpMutation();

  const handleClose = () => {
    dispatch({
      type: contextConstant.SET_SHOW_LOGIN_MODAL,
      payload: false,
    });
    // Reset form
    setUsername("");
    setPassword("");
    setConfirmPassword("");
    setUsernameReg("");
    setPasswordReg("");
    setEmaildReg("");
    setMessage("");
    setRegisterMessage("");
    setToggleLogin(false);
  };

  useEffect(() => {
    if (getMeSuccess && data) {
      socket.emit("disconnect_vip_rent_order", {
        userId: data.id,
      });

      // Close modal after successful login
      handleClose();
    }
  }, [isLoading, data, getMeSuccess]);

  const handleRegister = async () => {
    const trimmedUsername = usernamereg.trim();
    const trimmedPassword = passwordreg.trim();
    const trimmedConfirmPassword = confirmPassword.trim();
    const trimmedEmail = emailreg.trim();

    if (
      !trimmedUsername ||
      !trimmedPassword ||
      !trimmedConfirmPassword ||
      !trimmedEmail
    ) {
      setRegisterMessage("Vui lòng nhập đầy đủ thông tin");
      return;
    }

    if (!USERNAME_REGEX.test(trimmedUsername)) {
      setRegisterMessage("Tên người dùng không chứa kí tự đặc biệt");
      return;
    }
    if (trimmedUsername.length <= 5 || trimmedUsername.length >= 15) {
      setRegisterMessage(
        "Tên người dùng không được ít hơn 5 ký tự hoặc quá 15 ký tự"
      );
      return;
    }

    if (!REGEX_EMAIL.test(trimmedEmail)) {
      setRegisterMessage("Vui lòng nhập email hợp lệ");
      return;
    }

    if (trimmedPassword !== trimmedConfirmPassword) {
      setRegisterMessage("Mật khẩu không khớp ");
      return;
    }

    try {
      setProcessing(true);
      const response = await axios.post(
        `${domainServer}${APIs.register}`,
        {
          usernamereg: trimmedUsername,
          passwordreg: trimmedPassword,
          emailreg: trimmedEmail,
        },
        { withCredentials: false }
      );
      if (response.data) setRegisterMessage(response.data);
      if (response) {
        // Email verification is disabled: the account is active right away
        setUsername(trimmedUsername);
        setPassword("");
      }
    } catch (error) {
      setRegisterMessage(error?.response?.data);
    } finally {
      setProcessing(false);
    }
  };

  const handleLogin = async () => {
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername || !trimmedPassword) {
      setMessage("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    try {
      setProcessing(true);
      const response = await mutateLogin({
        username: trimmedUsername,
        password: trimmedPassword,
      });
      setMessage(response.message);
      if (response.token) {
        localStorage.setItem("accessToken", response.token);
      }
    } catch (error) {
      // Email verification is disabled: never send the user to the OTP screen
      setMessage(error?.response?.data.message);
    } finally {
      setProcessing(false);
    }
  };

  useEffect(() => {
    if (window?.electron?.receiveFromMain) {
      window.electron.receiveFromMain("open-url", (protocoUrl) => {
        const token = generateTokenFromProtoken(protocoUrl);
        if (token) {
          handleClose();
          navigate(`/verify/${token}`);
        }
      });
    }
  }, []);

  return (
    <Modal
      open={showLoginModal}
      onCancel={handleClose}
      footer={null}
      width={500}
      centered
      closable={true}
      className="login-modal"
    >
      <LoadingFullscreen
        loading={isPending || isSuccess || isLoading}
        className={`-top-32 ${(isSuccess || isLoading) && "!bg-bgPrimary"}`}
      />
      <div className="overflow-hidden">
        <style
          dangerouslySetInnerHTML={{
            __html: `
@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700,800,900');

.login-modal .ant-modal-content {
  background-color: #1f2029;
  color: #c4c3ca;
  font-family: 'Poppins', sans-serif;
}

.login-modal .ant-modal-close {
  color: #c4c3ca;
}

.login-modal .ant-modal-close:hover {
  color: #ffeba7;
}

[type="checkbox"]:checked,
[type="checkbox"]:not(:checked){
  position: absolute;
  left: -9999px;
}
.checkbox:checked + label,
.checkbox:not(:checked) + label{
  position: relative;
  display: block;
  text-align: center;
  width: 60px;
  height: 16px;
  border-radius: 8px;
  padding: 0;
  margin: 10px auto;
  cursor: pointer;
  background-color: #ffeba7;
}
.checkbox:checked + label:before,
.checkbox:not(:checked) + label:before{
  position: absolute;
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #ffeba7;
  background-color: #102770;
  font-family: 'unicons';
  content: '\\eb4f';
  z-index: 20;
  top: -10px;
  left: -10px;
  line-height: 36px;
  text-align: center;
  font-size: 24px;
  transition: all 0.5s ease;
}
.checkbox:checked + label:before {
  transform: translateX(44px) rotate(-270deg);
}

.card-3d-wrap {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 428px;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  perspective: 800px;
  margin-top: 20px;
}
.card-3d-wrapper {
  width: 100%;
  height: 100%;
  position:absolute;    
  top: 0;
  left: 0;  
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  transition: all 600ms ease-out; 
}
.card-front, .card-back {
  width: 100%;
  height: 100%;
  background-color: #2a2b38;
  background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg');
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 300%;
  position: absolute;
  border-radius: 6px;
  left: 0;
  top: 0;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
}
.card-back {
  transform: rotateY(180deg);
}
.checkbox:checked ~ .card-3d-wrap .card-3d-wrapper {
  transform: rotateY(180deg);
}
.center-wrap{
  position: absolute;
  width: 100%;
  padding: 0 35px;
  top: 50%;
  left: 0;
  transform: translate3d(0, -50%, 35px) perspective(100px);
  z-index: 20;
  display: block;
}

.form-group{ 
  position: relative;
  display: block;
    margin: 0;
    padding: 0;
}
.form-style {
  padding: 13px 20px;
  padding-left: 55px;
  height: 48px;
  width: 100%;
  font-weight: 500;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.5px;
  outline: none;
  color: #c4c3ca;
  background-color: #1f2029;
  border: none;
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;
  box-shadow: 0 4px 8px 0 rgba(21,21,21,.2);
}
.form-style:focus,
.form-style:active {
  border: none;
  outline: none;
  box-shadow: 0 4px 8px 0 rgba(21,21,21,.2);
}
.input-icon {
  position: absolute;
  top: 0;
  left: 18px;
  height: 48px;
  font-size: 24px;
  line-height: 48px;
  text-align: left;
  color: #ffeba7;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}

.form-group input:-ms-input-placeholder  {
  color: #c4c3ca;
  opacity: 0.7;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input::-moz-placeholder  {
  color: #c4c3ca;
  opacity: 0.7;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input:-moz-placeholder  {
  color: #c4c3ca;
  opacity: 0.7;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input::-webkit-input-placeholder  {
  color: #c4c3ca;
  opacity: 0.7;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input:focus:-ms-input-placeholder  {
  opacity: 0;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input:focus::-moz-placeholder  {
  opacity: 0;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input:focus:-moz-placeholder  {
  opacity: 0;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}
.form-group input:focus::-webkit-input-placeholder  {
  opacity: 0;
  -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
}

.btn{  
  border-radius: 4px;
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  -webkit-transition : all 200ms linear;
  transition: all 200ms linear;
  padding: 0 30px;
  letter-spacing: 1px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  text-align: center;
  border: none;
  background-color: #ffeba7;
  color: #102770;
  box-shadow: 0 8px 24px 0 rgba(255,235,167,.2);
  cursor: pointer;
}
.btn:active,
.btn:focus{  
  background-color: #102770;
  color: #ffeba7;
  box-shadow: 0 8px 24px 0 rgba(16,39,112,.2);
}
.btn:hover{  
  background-color: #102770;
  color: #ffeba7;
  box-shadow: 0 8px 24px 0 rgba(16,39,112,.2);
}
.btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
            `,
          }}
        />
        <link
          rel="stylesheet"
          href="https://unicons.iconscout.com/release/v2.1.9/css/unicons.css"
        />

        <div className="section">
          <div className="container">
            <div className="row full-height justify-content-center">
              <div className="col-12 text-center">
                <div className="section pb-5 pt-4 text-center">
                  <h6 className="mb-0 pb-2" style={{ color: "#c4c3ca" }}>
                    <span
                      className="text-warning cursor-pointer"
                      onClick={() => setToggleLogin(!toggleLogin)}
                      style={{ cursor: "pointer", color: "#ffeba7" }}
                    >
                      Đăng nhập{" "}
                    </span>
                    <span
                      className="text-danger cursor-pointer"
                      onClick={() => setToggleLogin(!toggleLogin)}
                      style={{ cursor: "pointer", color: "#ffeba7" }}
                    >
                      Đăng ký
                    </span>
                  </h6>
                  <input
                    className="checkbox"
                    type="checkbox"
                    id="reg-log"
                    name="reg-log"
                    checked={toggleLogin}
                    onChange={() => setToggleLogin(!toggleLogin)}
                  />
                  <label htmlFor="reg-log" />
                  <div className="card-3d-wrap mx-auto mt-4">
                    <div className="card-3d-wrapper">
                      <div className="card-front">
                        <div className="center-wrap w-full">
                          <div className="section text-center">
                            <h4 style={{ color: "#c4c3ca" }}>
                              Đăng nhập - Red Father Gaming App
                            </h4>
                            <p style={{ color: "#c4c3ca" }}>
                              Hệ thống thuê tài khoản game bản quyền Red Father Gaming App
                            </p>
                            <div className="pt-1">
                              <div className="form-group">
                                <input
                                  value={username}
                                  className="form-style"
                                  onChange={(e) => setUsername(e.target.value)}
                                  placeholder="Nhập tài khoản"
                                  autoComplete="off"
                                />
                                <i className="input-icon uil uil-user" />
                              </div>
                              <div className="form-group mt-2">
                                <input
                                  type="password"
                                  value={password}
                                  className="form-style"
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="Nhập mật khẩu"
                                  autoComplete="off"
                                />
                                <i className="input-icon uil uil-lock-alt" />
                              </div>
                            </div>
                            <button
                              onClick={handleLogin}
                              className={`btn mt-4 ${
                                processing || isSending ? "disabled" : ""
                              }`}
                              disabled={processing || isSending}
                            >
                              {processing || isSending
                                ? "Đang xử lý..."
                                : "Đăng nhập"}
                            </button>
                            <p className="mt-2" style={{ color: "#c4c3ca" }}>
                              {message}
                            </p>
                            <p className="text-center">
                              <Link
                                to="/forgot-password"
                                className="link"
                                style={{ color: "#c4c3ca" }}
                                onClick={handleClose}
                              >
                                Quên mật khẩu?
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card-back ">
                        <div className=" relative w-100 h-[440px] top-1 left-0 z-20 block ">
                          <div className="section text-center">
                            <h4 className="pt-3" style={{ color: "#c4c3ca" }}>
                              Đăng ký - Red Father Gaming App
                            </h4>
                            <p style={{ color: "#c4c3ca" }}>
                              Hệ thống thuê tài khoản game bản quyền Red Father Gaming App
                            </p>
                            <div className="px-8">
                              <div className="form-group">
                                <input
                                  type="text"
                                  value={usernamereg}
                                  className="form-style"
                                  onChange={(e) =>
                                    setUsernameReg(e.target.value)
                                  }
                                  placeholder="Nhập tài khoản..."
                                  autoComplete="off"
                                  required
                                />
                                <i className="input-icon uil uil-user" />
                              </div>
                              <div className="form-group mt-2">
                                <input
                                  type="password"
                                  value={passwordreg}
                                  className="form-style"
                                  onChange={(e) =>
                                    setPasswordReg(e.target.value)
                                  }
                                  placeholder="Nhập mật khẩu..."
                                  autoComplete="off"
                                  required
                                />
                                <i className="input-icon uil uil-lock" />
                              </div>
                              <div className="form-group mt-2">
                                <input
                                  type="password"
                                  value={confirmPassword}
                                  className="form-style"
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                  autoComplete="off"
                                  placeholder="Xác nhận mật khẩu..."
                                  required
                                />
                                <i className="input-icon uil uil-lock" />
                              </div>
                              <div className="form-group mt-2">
                                <input
                                  type="email"
                                  value={emailreg}
                                  className="form-style"
                                  onChange={(e) => setEmaildReg(e.target.value)}
                                  autoComplete="off"
                                  placeholder="Nhập email..."
                                  required
                                />
                                <i className="input-icon uil uil-at" />
                              </div>
                            </div>
                            <button
                              onClick={handleRegister}
                              className={`btn mt-4 ${
                                processing ? "disabled" : ""
                              }`}
                              disabled={processing}
                            >
                              {processing ? "Đang xử lý..." : "Đăng ký"}
                            </button>
                            {toggleLogin ? (
                              <p
                                className=" mt-1"
                                style={{ color: "#c4c3ca" }}
                              >
                                {registerMessage}
                              </p>
                            ) : (
                              <p className=" mt-1" style={{ color: "#c4c3ca" }}>
                                {message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LoginModal;
